import React, { useState, useEffect } from 'react';
import { AdminLayout } from '../../components/admin/AdminLayout';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { Textarea } from '../../components/ui/textarea';
import { toast } from 'sonner';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const AdminServicesGroup = () => {
  const [content, setContent] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    axios.get(`${API}/content/services_group`).then(r => setContent(r.data)).catch(console.error);
  }, []);

  const set = (key, val) => setContent(prev => ({ ...prev, [key]: val }));

  const save = async () => {
    setSaving(true);
    try {
      await axios.put(`${API}/content/services_group`, { data: content });
      toast.success('Group training section updated');
    } catch { toast.error('Failed to save'); }
    finally { setSaving(false); }
  };

  if (!content) return <AdminLayout title="Edit Group Training"><div className="py-8 text-center text-gray-400">Loading...</div></AdminLayout>;

  return (
    <AdminLayout title="Edit Group & On-Site Training">
      <div className="max-w-xl space-y-6">
        <Card className="border-2">
          <CardHeader><CardTitle>Section Content</CardTitle></CardHeader>
          <CardContent className="space-y-4">
            <div>
              <Label>Section Title</Label>
              <Input value={content.title || ''} onChange={e => set('title', e.target.value)} className="mt-1" />
            </div>
            <div>
              <Label>Subtitle</Label>
              <Input value={content.subtitle || ''} onChange={e => set('subtitle', e.target.value)} className="mt-1" />
            </div>
            <div>
              <Label>Description Paragraph</Label>
              <Textarea rows={3} value={content.description || ''} onChange={e => set('description', e.target.value)} className="mt-1" />
            </div>
            <div>
              <Label>Bullet Points (one per line)</Label>
              <Textarea
                rows={8}
                value={content.bullet_points || ''}
                onChange={e => set('bullet_points', e.target.value)}
                className="mt-1"
                placeholder="Healthcare facilities and clinics&#10;Schools and daycare centers"
              />
            </div>
            <div>
              <Label>Button Text</Label>
              <Input value={content.cta_text || ''} onChange={e => set('cta_text', e.target.value)} className="mt-1" />
            </div>
          </CardContent>
        </Card>

        <Button onClick={save} disabled={saving} className="bg-red-600 hover:bg-red-700 text-white w-full">
          {saving ? 'Saving...' : 'Save Changes'}
        </Button>
      </div>
    </AdminLayout>
  );
};
